import React from "react";
import { FormikContext, FormikProps } from "formik";

interface FormProps {
  form: FormikProps<any>;
  children: React.ReactNode;
}

const Form: React.FC<FormProps> = ({ children, form }) => {
  return <FormikContext.Provider value={form}>{children}</FormikContext.Provider>;
};

export { Form };
